import React, { useState, useEffect } from 'react';
import SideBar from '../Components/SideBar';
import {
  fetchAdminTerminalsRequests,
  fetchAdminTerminalsServicesRequests,
  fetchAdminCategoryRequests,
  fetchAdminTerminalsAdsRequests,
  fetchAdminTerminalsQRCodesRequests,
  updateCategoryStatus,
  updateTerminalsServicesStatus,
  updateTerminalsStatus,
  updateTerminalsAdsStatus,
  updateTerminalsQRCodesStatus,
  fetchCategoryById,
  fetchQRCodeById,
  fetchTerminalAdById,
  fetchTerminalById,
  fetchTerminalServiceById,
} from '../Services/SuperAdminApi';
import forumStatus from '../Constants/forumStatus';
import { useTranslation } from "react-i18next";

const formatDate = (isoDate) =>
  new Date(isoDate).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
const dummy = {
  data: {
    "status": "success",
    "data": {
      "logo_url": "https://lh3.googleusercontent.com/a/ACg8ocLb9uR5M8N5yTpKauGAt0kaPFueT5y4yQW0LELwtqwUBGQJPLkM=s96-c",
      "header_url": "https://lh3.googleusercontent.com/a/ACg8ocLb9uR5M8N5yTpKauGAt0kaPFueT5y4yQW0LELwtqwUBGQJPLkM=s96-c",
      "background_url": null,
      "lang": "de",
      "template": "A",
      "categories": [
        {
          "id": 50,
          "name": "ServiceTourismLeisure",
          "metadata": {
            "logo": "https://lh3.googleusercontent.com/a/ACg8ocLb9uR5M8N5yTpKauGAt0kaPFueT5y4yQW0LELwtqwUBGQJPLkM=s96-c"
          },
          "parentCategoryId": null
        },
        {
          "id": 51,
          "name": "ServiceCyclingRoutes",
          "metadata": {
            "logo": "https://lh3.googleusercontent.com/a/ACg8ocLb9uR5M8N5yTpKauGAt0kaPFueT5y4yQW0LELwtqwUBGQJPLkM=s96-c"
          },
          "parentCategoryId": 50
        }
      ],
      "services": [
        {
          "id": 16,
          "title": "services3",
          "description": "ajsfgasf asgfdhagfs hagsfd ",
          "link": "https://test.com",
          "imageUrl": "https://lh3.googleusercontent.com/a/ACg8ocLb9uR5M8N5yTpKauGAt0kaPFueT5y4yQW0LELwtqwUBGQJPLkM=s96-c"
        },
        {
          "id": 17,
          "title": "services4",
          "description": "ajsfgasf asgfdhagfs hagsfd ",
          "link": "https://test.com",
          "imageUrl": "https://lh3.googleusercontent.com/a/ACg8ocLb9uR5M8N5yTpKauGAt0kaPFueT5y4yQW0LELwtqwUBGQJPLkM=s96-c"
        },
        {
          "id": 18,
          "title": "services5",
          "description": "ajsfgasf asgfdhagfs hagsfd ",
          "link": "https://test.com",
          "imageUrl": "https://lh3.googleusercontent.com/a/ACg8ocLb9uR5M8N5yTpKauGAt0kaPFueT5y4yQW0LELwtqwUBGQJPLkM=s96-c"
        }
      ],
      "qrCodes": [],
      "advertisements": [],
      "userEmail": "naren12345@mailinaitor.com"
    }
  }
}

const tabsIdsToApis = {
  terminal: {
    fetchAll: fetchAdminTerminalsRequests,
    fetchById: fetchTerminalById,
    updateStatus: updateTerminalsStatus,
  },
  category: {
    fetchAll: fetchAdminCategoryRequests,
    fetchById: fetchCategoryById,
    updateStatus: updateCategoryStatus,
  },
  services: {
    fetchAll: fetchAdminTerminalsServicesRequests,
    fetchById: fetchTerminalServiceById,
    updateStatus: updateTerminalsServicesStatus,
  },
  ads: {
    fetchAll: fetchAdminTerminalsAdsRequests,
    fetchById: fetchTerminalAdById,
    updateStatus: updateTerminalsAdsStatus,
  },
  qrcodes: {
    fetchAll: fetchAdminTerminalsQRCodesRequests,
    fetchById: fetchQRCodeById,
    updateStatus: updateTerminalsQRCodesStatus,
  },
}

const AdminRequests = () => {
  const { t } = useTranslation();
  const tabs = [
    { id: "terminal", label: "Terminal", content: "Terminal configs request" },
    // { id: "category", label: t("categoryTitle"), content: "Category request" },
    // { id: "services", label: t("serviceLabel"), content: "Services request" },
    // { id: "ads", label: t("ads"), content: "Ads request" },
    // { id: "qrcodes", label: t("qrCode"), content: "QR Codes request" },
  ];
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [modalstatus, setModalStatus] = useState(null);
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [list, setList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showRequestModal, setRequestModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false)
  const [successModal, setSuccessModal] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  const renderModalContent = () => {
    // Increase max height for accordions and reduce dropdown height
    const accordionMaxHeight = "max-h-96"; // ~384px, increased for more content

    switch (activeTab) {
      case "terminal":
        return (
          <>
            {/* Terminal Accordion */}
            <details
              open={openSection === "terminal"}
              className="mb-2 border rounded"
            >
              <summary
                className="cursor-pointer px-4 py-1 font-semibold bg-gray-100 hover:bg-gray-200"
                onClick={e => {
                  e.preventDefault();
                  setOpenSection(openSection === "terminal" ? null : "terminal");
                }}
              >
                Terminal
              </summary>
              <div
                className={`px-4 py-2 overflow-x-auto ${accordionMaxHeight}`}
                onClick={e => e.stopPropagation()}
              >
                <table className="min-w-full text-xs text-gray-800 border">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="px-2 py-1 font-semibold border">{t("header")}</th>
                      <th className="px-2 py-1 font-semibold border">Logo</th>
                      <th className="px-2 py-1 font-semibold border">{t("city")}</th>
                      <th className="px-2 py-1 font-semibold border">{t("map_link")}</th>
                      <th className="px-2 py-1 font-semibold border">{t("latitude")}</th>
                      <th className="px-2 py-1 font-semibold border">{t("longitude")}</th>
                      <th className="px-2 py-1 font-semibold border">{t("template")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="px-2 py-1 border">
                        {selectedRequest.header_url ? (
                          <span
                            className="text-blue-600 underline cursor-pointer"
                            onClick={() => window.open(selectedRequest.header_url, "_blank")}
                          >
                            Header
                          </span>
                        ) : "-"}
                      </td>
                      <td className="px-2 py-1 border">
                        {selectedRequest.logo_url ? (
                          <span
                            className="text-blue-600 underline cursor-pointer"
                            onClick={() => window.open(selectedRequest.logo_url, "_blank")}
                          >
                            Logo
                          </span>
                        ) : "-"}
                      </td>
                      <td className="px-2 py-1 border">{selectedRequest.cityName || "-"}</td>
                      <td className="px-2 py-1 border">
                        {selectedRequest.link ? (
                          <span
                            className="text-blue-600 underline cursor-pointer"
                            onClick={() => window.open(selectedRequest.link, "_blank")}
                          >
                            {t("map_link")}
                          </span>
                        ) : "-"}
                      </td>
                      <td className="px-2 py-1 border">{selectedRequest.latitude || "-"}</td>
                      <td className="px-2 py-1 border">{selectedRequest.longitude || "-"}</td>
                      <td className="px-2 py-1 border">{selectedRequest.template || "-"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </details>

            {/* Categories Accordion */}
            {(selectedRequest.categories && selectedRequest.categories.length > 0) && (
              <details
                open={openSection === "categories"}
                className="mb-2 border rounded"
              >
                <summary
                  className="cursor-pointer px-4 py-1 font-semibold bg-gray-100 hover:bg-gray-200"
                  onClick={e => {
                    e.preventDefault();
                    setOpenSection(openSection === "categories" ? null : "categories");
                  }}
                >
                  {t("Categories")}
                </summary>
                <div
                  className={`px-4 py-2 overflow-x-auto ${accordionMaxHeight}`}
                  onClick={e => e.stopPropagation()}
                >
                  <table className="min-w-full text-xs text-gray-800 border">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="px-2 py-1 font-semibold border">Name</th>
                        <th className="px-2 py-1 font-semibold border">Logo</th>
                        <th className="px-2 py-1 font-semibold border">{t("parentCategory")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedRequest.categories.map(cat => (
                        <tr key={cat.id}>
                          <td className="px-2 py-1 border">{cat.name}</td>
                          <td className="px-2 py-1 border">
                            {(cat.metadata?.logo || cat?.image) ? (
                              <span
                                className="text-blue-600 underline cursor-pointer"
                                onClick={() => window.open(cat.metadata?.logo || cat?.image, "_blank")}
                              >
                                Logo
                              </span>
                            ) : "-"}
                          </td>
                          <td className="px-2 py-1 border">{selectedRequest.categories.find(el => el.id == cat.parentCategoryId)?.name || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>
            )}

            {/* Services Accordion */}
            {(selectedRequest.services && selectedRequest.services.length > 0) && (
              <details
                open={openSection === "services"}
                className="mb-2 border rounded"
              >
                <summary
                  className="cursor-pointer px-4 py-1 font-semibold bg-gray-100 hover:bg-gray-200"
                  onClick={e => {
                    e.preventDefault();
                    setOpenSection(openSection === "services" ? null : "services");
                  }}
                >
                  {t("Services")}
                </summary>
                <div
                  className={`px-4 py-2 overflow-x-auto ${accordionMaxHeight}`}
                  onClick={e => e.stopPropagation()}
                >
                  <table className="min-w-full text-xs text-gray-800 border">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="px-2 py-1 font-semibold border">{t("title")}</th>
                        <th className="px-2 py-1 font-semibold border">{t("descriptionLabel")}</th>
                        <th className="px-2 py-1 font-semibold border">Link</th>
                        <th className="px-2 py-1 font-semibold border">{t("imageLabel")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedRequest.services.map(service => (
                        <tr key={service.id}>
                          <td className="px-2 py-1 border">{service.title}</td>
                          <td className="px-2 py-1 border">{service.description}</td>
                          <td className="px-2 py-1 border">
                            {service.link ? (
                              <a
                                href={service.link.startsWith('http://') || service.link.startsWith('https://')
                                  ? service.link
                                  : `https://${service.link}`
                                } target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                              >
                                Link
                              </a>
                            ) : "-"}
                          </td>
                          <td className="px-2 py-1 border">
                            {service.imageUrl ? (
                              <span
                                className="text-blue-600 underline cursor-pointer"
                                onClick={() => window.open(service.imageUrl, "_blank")}
                              >
                                Image
                              </span>
                            ) : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>
            )}

            {/* Ads Accordion */}
            {(selectedRequest.advertisements && selectedRequest.advertisements.length > 0) && (
              <details
                open={openSection === "ads"}
                className="mb-2 border rounded"
              >
                <summary
                  className="cursor-pointer px-4 py-1 font-semibold bg-gray-100 hover:bg-gray-200"
                  onClick={e => {
                    e.preventDefault();
                    setOpenSection(openSection === "ads" ? null : "ads");
                  }}
                >
                  Ads
                </summary>
                <div
                  className={`px-4 py-2 overflow-x-auto ${accordionMaxHeight}`}
                  onClick={e => e.stopPropagation()}
                >
                  <table className="min-w-full text-xs text-gray-800 border">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="px-2 py-1 font-semibold border">{t("title")}</th>
                        <th className="px-2 py-1 font-semibold border">{t("descriptionLabel")}</th>
                        <th className="px-2 py-1 font-semibold border">{t("imageLabel")}</th>
                        <th className="px-2 py-1 font-semibold border">Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedRequest.advertisements.map(ad => (
                        <tr key={ad.id}>
                          <td className="px-2 py-1 border">{ad.title}</td>
                          <td className="px-2 py-1 border">{ad.description}</td>
                          <td className="px-2 py-1 border">
                            {ad.imageUrl ? (
                              <span
                                className="text-blue-600 underline cursor-pointer"
                                onClick={() => window.open(ad.imageUrl, "_blank")}
                              >
                                Image
                              </span>
                            ) : "-"}
                          </td>
                          <td className="px-2 py-1 border">
                            {ad.link ? (
                              <a
                                href={ad.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                              >
                                Link
                              </a>
                            ) : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>
            )}

            {/* QR Codes Accordion */}
            {(selectedRequest.qrCodes && selectedRequest.qrCodes.length > 0) && (
              <details
                open={openSection === "qrcodes"}
                className="mb-2 border rounded"
              >
                <summary
                  className="cursor-pointer px-4 py-1 font-semibold bg-gray-100 hover:bg-gray-200"
                  onClick={e => {
                    e.preventDefault();
                    setOpenSection(openSection === "qrcodes" ? null : "qrcodes");
                  }}
                >
                  QR Codes
                </summary>
                <div
                  className={`px-4 py-2 overflow-x-auto ${accordionMaxHeight}`}
                  onClick={e => e.stopPropagation()}
                >
                  <table className="min-w-full text-xs text-gray-800 border">
                    <thead>
                      <tr className="bg-gray-50">
                        <th className="px-2 py-1 font-semibold border">Name</th>
                        <th className="px-2 py-1 font-semibold border">{t("imageLabel")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedRequest.qrCodes.map(qr => (
                        <tr key={qr.id}>
                          <td className="px-2 py-1 border">{qr.title}</td>
                          <td className="px-2 py-1 border">
                            {qr.imageUrl ? (
                              <span
                                className="text-blue-600 underline cursor-pointer"
                                onClick={() => window.open(qr.imageUrl, "_blank")}
                              >
                                {t("imageLabel")}
                              </span>
                            ) : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </details>
            )}
          </>
        );
      case "category":
        return (
          <div className="flex justify-center">
            <table className="min-w-[350px] text-sm text-gray-800 border"> {/* text-xs -> text-sm */}
              <tbody>
                <tr>
                  <td className="font-semibold px-2 py-2 border align-top text-base">{t("descriptionLabel")}</td>
                  <td className="px-2 py-2 border align-top text-base">{selectedRequest.description || "-"}</td>
                </tr>
                <tr>
                  <td className="font-semibold px-2 py-2 border align-top text-base">{t("webLink")}</td>
                  {selectedRequest.website ? <td className="px-2 py-2 border align-top text-base">
                    <span
                      className="text-blue-600 underline cursor-pointer"
                      onClick={() => window.open(selectedRequest.website, "_blank")}
                    >
                      {selectedRequest.website}
                    </span>
                  </td>
                    : <td className="px-2 py-2 border align-top text-base">{"-"}</td>}
                </tr>
                {(selectedRequest.metadata?.logo || selectedRequest.image) && (
                  <tr>
                    <td className="font-semibold px-2 py-2 border align-top text-base">Logo</td>
                    <td className="px-2 py-2 border align-top text-base">
                      <span
                        className="text-blue-600 underline cursor-pointer"
                        onClick={() => window.open(selectedRequest.metadata?.logo || selectedRequest?.image, "_blank")}
                      >
                        logo
                      </span>
                    </td>
                  </tr>
                )}
                {Array.isArray(selectedRequest.scrapers) && selectedRequest.scrapers.length > 0 && (
                  <tr>
                    <td className="font-semibold px-2 py-2 border align-top text-base">Scraper Links</td>
                    <td className="px-2 py-2 border align-top text-base">
                      <ul className="list-disc ml-4">
                        {selectedRequest.scrapers.map((scraper, idx) => (
                          <li key={idx}>
                            {scraper.link ? (
                              <a
                                href={scraper.link.startsWith('http') ? scraper.link : `https://${scraper.link}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline"
                              >
                                {scraper.link}
                              </a>
                            ) : "-"}
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div >
        )
      case "qrcodes":
        return (
          <div className="flex justify-center">
            <table className="min-w-[350px] text-sm text-gray-800 border"> {/* text-xs -> text-sm */}
              <tbody>
                {/* <tr>
                  <td className="font-semibold px-2 py-2 border align-top text-base">Description</td>
                  <td className="px-2 py-2 border align-top text-base">{selectedRequest.description}</td>
                </tr> */}
                <tr>
                  <td className="font-semibold px-2 py-2 border align-top text-base">QR Code</td>
                  <td className="px-2 py-2 border align-top text-base">
                    <span
                      className="text-blue-600 underline cursor-pointer"
                      onClick={() => window.open(selectedRequest.imageUrl, "_blank")}
                    >
                      QR Code
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )
      case "ads":
        return (
          <div className="flex justify-center">
            <table className="min-w-[350px] text-sm text-gray-800 border"> {/* text-xs -> text-sm */}
              <tbody>
                {selectedRequest.description && <tr>
                  <td className="font-semibold px-2 py-2 border align-top text-base">{t("descriptionLabel")}</td>
                  <td className="px-2 py-2 border align-top text-base">{selectedRequest.description}</td>
                </tr>}
                <tr>
                  <td className="font-semibold px-2 py-2 border align-top text-base">{t("posterLabel")}</td>
                  <td className="px-2 py-2 border align-top text-base">
                    <span
                      className="text-blue-600 underline cursor-pointer"
                      onClick={() => window.open(selectedRequest.imageUrl, "_blank")}
                    >
                      {t("posterLabel")}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )
      case "services":
        return (
          <div className="flex justify-center">
            <table className="min-w-[350px] text-sm text-gray-800 border">
              <tbody>
                <tr>
                  <td className="font-semibold px-2 py-2 border align-top text-base">{t("descriptionLabel")}</td>
                  <td className="px-2 py-2 border align-top text-base">{selectedRequest.description}</td>
                </tr>
                <tr>
                  <td className="font-semibold px-2 py-2 border align-top text-base">Link</td>
                  <td className="px-2 py-2 border align-top text-base">
                    {selectedRequest.link ? (
                      <a
                        href={selectedRequest.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        {selectedRequest.link}
                      </a>
                    ) : "-"}
                  </td>
                </tr>
                {selectedRequest.imageUrl && (
                  <tr>
                    <td className="font-semibold px-2 py-2 border align-top text-base">{t("imageLabel")}</td>
                    <td className="px-2 py-2 border align-top text-base">
                      <span
                        className="text-blue-600 underline cursor-pointer"
                        onClick={() => window.open(selectedRequest.imageUrl, "_blank")}
                      >
                        {t("imageLabel")}
                      </span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      default:
        return null
    }
  }

  const renderModal = () => {
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
        <div
          className="bg-white p-6 rounded-2xl max-w-lg w-full relative flex flex-col"
          style={{
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <button
            className="absolute top-3 right-4 text-gray-500 hover:text-black text-2xl"
            onClick={() => setSelectedRequest(null)}
          >
            &times;
          </button>
          <h2 className="text-xl font-bold mb-2">{selectedRequest.title || selectedRequest.name}</h2>
          {selectedRequest.createdAt && (
            <p className="text-sm text-gray-500 mb-4">
              {t("createdAt")}: {formatDate(selectedRequest.createdAt)}
            </p>
          )}
          <div className="mb-6">{renderModalContent()}</div>
          {selectedRequest && (selectedRequest.userEmail || selectedRequest.createdByEmail) && (
            <div className="text-sm text-gray-500 mb-4">
              <div className="font-semibold mb-1">{t("candidate_proposed")}:</div>
              {selectedRequest.createdByUserName && <div>
                <span className="font-medium">Name:</span> {selectedRequest.createdByUserName}
              </div>}
              <div>
                <span className="font-medium">Email:</span> {selectedRequest.userEmail || selectedRequest.createdByEmail || "-"}
              </div>
            </div>
          )}
          <div className="flex justify-end gap-3 mt-auto">
            <button
              onClick={handleReject}
              className="px-4 py-2 text-sm bg-red-500 text-white rounded hover:bg-red-600"
            >
              {t("reject")}
            </button>
            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm bg-green-500 text-white rounded hover:bg-green-600"
            >
              {t("accept")}
            </button>
          </div>
        </div>
      </div>
    )
  }

  const fetchRequestList = async (id) => {
    try {
      setList(null);
      setIsLoading(true);
      const res = await tabsIdsToApis[id]?.fetchAll();
      if (res?.data?.data.length) {
        const data = res.data.data.map(el => (el.status = el.isApproved || el.status, el)).filter(el =>
          (el.status && (el.status?.toLowerCase() == forumStatus.status["1"]?.toLowerCase()))
        );
        setList(data)
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error(e)
    }
  }

  useEffect(() => {
    fetchRequestList(activeTab)
  }, []);

  const onTabClick = (id) => {
    setActiveTab(id);
    fetchRequestList(id);
  }

  const onClickRequest = async (req) => {
    let newReq = structuredClone(req);
    try {
      setIsLoading(true);
      let res = await tabsIdsToApis[activeTab]?.fetchById(req.id);
      newReq = { ...req, ...(res?.data?.data || {}) };
      console.log(newReq);
      setIsLoading(false);
    }
    catch (e) {
      setIsLoading(false);
      console.error(e);
    }
    setSelectedRequest(newReq);
    setRequestModal(true)
  }


  function handleAccept() {
    setModalStatus("Accepted");
    setConfirmModal(true);
    setRequestModal(false)
  }
  function handleReject() {
    setRequestModal(false)
    setModalStatus("Rejected");
    setConfirmModal(true);
  }
  const [rejectReason, setRejectReason] = useState('');
  const handelUpdateStatus = async () => {
    const params = {}
    const id = selectedRequest.id;
    setConfirmModal(false);
    if (modalstatus == "Accepted") params.status = forumStatus.statusByName.Accepted;
    else if (modalstatus == "Rejected") { params.status = forumStatus.statusByName.Rejected; params.reason = rejectReason };
    try {
      setIsLoading(true);
      await tabsIdsToApis[activeTab]?.updateStatus(id, params);
      setSuccessModal(true);
      setRejectReason('');
      setSelectedRequest(null);
      setTimeout(() => {
        setSuccessModal(false);
      }, 1000);
      fetchRequestList(activeTab);
    } catch (e) {
      setIsLoading(false);
      setRejectReason('');
      console.error(e)
    }
  }
  return (
    <div className="bg-gray-800 body-font relative min-h-screen">
      <SideBar />
      <div className="container w-auto px-5 py-2">
        {isLoading &&
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="text-white">
              {t("loading")}
            </div>
          </div>}
        <div className="max-w-4xl mx-auto p-6">
          <h2 className="text-2xl font-bold mb-4 text-white">{t("adminTerminalRequestLabel")}</h2>
          <div className="space-y-4">
            <div className="flex">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`px-4 py-2 font-medium text-md text-bold transition-all duration-200 ${activeTab === tab.id
                    ? "border-b-2 border-blue-500 text-blue-600"
                    : "text-white hover:text-blue-500"
                    }`}
                  onClick={() => onTabClick(tab.id)}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            <div className="p-4 bg-white border border-gray-200 rounded-b-md space-y-4 min-h-[100px] flex flex-col items-center justify-center">
              {list && list.length > 0 ? (
                list.map((req) => (
                  <div
                    key={req.id}
                    onClick={() => onClickRequest(req)}
                    className="w-full p-4 border rounded-xl shadow bg-white hover:shadow-md transition cursor-pointer"
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-semibold text-lg">{req.title || req.name}</h3>
                        <p className="text-sm text-gray-600">{req.description}</p>
                      </div>
                      {req.createdAt && (
                        <span className="text-sm text-gray-500">{formatDate(req.createdAt)}</span>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                !isLoading && (
                  <div className="text-center text-gray-500 text-sm">
                    {t("No requests found")}
                  </div>
                )
              )}
            </div>

          </div>
          {
            successModal && (
              <div className={`fixed top-4 right-2 p-3 rounded-md text-xs ${modalstatus === "Accepted"
                ? "bg-green-100 text-green-800"
                : "bg-red-100 text-red-800"
                }`}>
                {`Request ${modalstatus === "Accepted" ? "accepted" : "rejected"} successfully!`}
              </div>
            )
          }

          {
            confirmModal && (
              <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
                <div className="absolute rounded-md top-40  w-[50%] p-4 bg-white shadow-lg">
                  <div className='w-full flex items-center justify-end cursor-pointer' onClick={() => { setConfirmModal(false); setSelectedRequest(null) }}>
                    <button
                      className="absolute top-3 right-4 text-gray-500 hover:text-black text-2xl"
                    >
                      &times;
                    </button>
                  </div>
                  <div className="flex items-center flex-col gap-4 justify-center h-full">
                    <p className={`text-lg text-bold align-left ${modalstatus === "Accepted" ? "text-green-600" : "text-red-600"}`}>
                      {`Do you want to ${modalstatus === "Accepted" ? "accept" : "reject"} the request?`}
                    </p>
                    {modalstatus !== "Accepted" && <textarea
                      rows={4}
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e.target.value)}
                      placeholder="Please enter your reason(optional)"
                      className="w-full border border-gray-300 rounded px-3 py-2 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    }
                  </div>
                  <div className='w-full flex items-center justify-center gap-3 mt-4'>
                    <button className='border rounded-md p-1 w-20 bg-red-600 text-white font-bold' onClick={handelUpdateStatus}>confirm</button>
                  </div>
                </div>
              </div>
            )
          }
          {/* Modal */}
          {selectedRequest && showRequestModal && renderModal()}
        </div>
      </div>
    </div>
  );
}

export default AdminRequests;
